export default "__VITE_ASSET__7109e202__"